import { normalizeRefundPolicy } from './refundPolicy';

const BASE_WARNING_STYLES = {
  SAFE: { bg: '#ecfdf5', color: '#047857', border: '#a7f3d0', label: 'On Track' },
  REMINDER: { bg: '#fffbeb', color: '#b45309', border: '#fde68a', label: 'Refund Due' },
  CLOSED: { bg: '#f3f4f6', color: '#374151', border: '#d1d5db', label: 'Closed' },
  PENALTY_APPLIED: { bg: '#fef2f2', color: '#991b1b', border: '#fecaca', label: 'Penalty Applied' },
  NONE: { bg: '#f8fafc', color: '#64748b', border: '#e2e8f0', label: '—' },
};

export const getWarningStyle = (level, policyInput) => {
  const policy = normalizeRefundPolicy(policyInput);
  if (level === 'PENALTY_50') {
    return {
      bg: '#fff7ed',
      color: '#c2410c',
      border: '#fdba74',
      label: `₹${policy.firstPenaltyAmount} Penalty`,
    };
  }
  if (level === 'PENALTY_100') {
    return {
      bg: '#fef2f2',
      color: '#b91c1c',
      border: '#fecaca',
      label: `₹${policy.secondPenaltyAmount} Penalty`,
    };
  }
  return BASE_WARNING_STYLES[level] || BASE_WARNING_STYLES.NONE;
};

/** @deprecated use getWarningStyle */
export const WARNING_STYLES = {
  ...BASE_WARNING_STYLES,
  PENALTY_50: { bg: '#fff7ed', color: '#c2410c', border: '#fdba74', label: 'Late Penalty' },
  PENALTY_100: { bg: '#fef2f2', color: '#b91c1c', border: '#fecaca', label: 'Critical Penalty' },
};

export const isRefundPending = (status) =>
  ['ORDER_FORM_FILLED', 'ORDER_FORM_REFILL_REQUEST'].includes(status);

export const REFUND_CLOSING_SOON_DAYS = 5;

export const isRefundClosingSoon = (timeline) =>
  timeline?.refundFormOpen
  && timeline?.daysLeftToClose > 0
  && timeline?.daysLeftToClose <= REFUND_CLOSING_SOON_DAYS;

export const buildDeadlineSummary = (timeline) => {
  if (!timeline) return null;
  if (!timeline.refundRequired) return null;

  const policy = normalizeRefundPolicy(timeline.policy);

  if (!timeline.refundFormOpen) {
    return {
      level: 'CLOSED',
      text: `Refund form closed (${policy.formCloseDay}-day limit reached)`,
    };
  }

  return {
    level: timeline.warningLevel || 'SAFE',
    text: timeline.daysLeftToClose != null
      ? `${timeline.daysLeftToClose} day(s) left before form closes`
      : timeline.warningMessage,
    penalty: timeline.penaltyAmount,
    netPayout: timeline.netPayoutAmount,
  };
};

export { formatDisplayDate } from './dateTime';

export const getFormCloseDay = (policyInput) =>
  normalizeRefundPolicy(policyInput).formCloseDay;

export const buildClosedRefundMessage = (policyInput) => {
  const policy = normalizeRefundPolicy(policyInput);
  return `Refund form is closed. The ${policy.formCloseDay}-day deadline has passed for this order.`;
};
